import { render, staticRenderFns } from "./CreateCBSR.vue?vue&type=template&id=74c8d4b0&scoped=true&"
import script from "./CreateCBSR.vue?vue&type=script&lang=ts&"
export * from "./CreateCBSR.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c8d4b0",
  null
  
)

export default component.exports